import { addDays, isBefore } from 'date-fns';
import { ChampionshipStatus } from 'modules/championship/domain/enums/championship-status';
import { ChampionshipListItem, ChampionshipsListResponseDto } from 'modules/championship/domain/interfaces/championship-list-item';
import { baseApi } from 'shared/api/base-api';

export interface ListChampionshipsArgs {
  tournamentId: number;
  limit: number;
  offset: number;
  namePart?: string;
  afterDate?: string;
  beforeDate?: string;
}

const getChampionshipsQuery = `#graphql
query getTournamentChampionships($id: Int!, $limit: Int, $offset: Int, $beforeDate: String, $afterDate: String, $namePart: String) {
  championshipsPaginated(input: {
    tournamentId: $id,
    limit: $limit,
    offset: $offset,
    beforeDate: $beforeDate,
    afterDate: $afterDate,
    namePart: $namePart
  }) {
    id
    name
    startDate
    endDate
    locations {
      id
      address {
        city
        country
      }
    }
  }
}
`;

// Примечание: бэкенд сейчас не возвращает total/totalCount для championshipsPaginated
// Возвращаем плоский массив ChampionshipListItem[], а инвалидацию делаем по id + PARTIAL-LIST
export const championshipsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    listChampionships: build.query<ChampionshipListItem[], ListChampionshipsArgs>({
      query: ({ tournamentId, limit, offset, beforeDate, afterDate, namePart }) => ({
        query: getChampionshipsQuery,
        variables: { id: tournamentId, limit, offset, beforeDate, afterDate, namePart },
      }),
      transformResponse: (raw: ChampionshipsListResponseDto): ChampionshipListItem[] => {
        if (raw?.championshipsPaginated) {
          return raw.championshipsPaginated.map((championship) => {
            const applicationsDeadline = addDays(Date.now(), 3);
            const areApplicationsClosed = championship.endDate && isBefore(new Date(championship.endDate), applicationsDeadline);
            championship.status = areApplicationsClosed ? ChampionshipStatus.CLOSE : ChampionshipStatus.OPEN;

            return championship;
          });
        }

        return [];
      },
      providesTags: (result) =>
        result && result.length
          ? [
              ...result.map((c) => ({ type: 'Championship' as const, id: c.id })),
              { type: 'Championship' as const, id: 'PARTIAL-LIST' },
            ]
          : [{ type: 'Championship' as const, id: 'PARTIAL-LIST' }],
      keepUnusedDataFor: 60, // секунд — кэш живёт после отписки
    }),
  }),
  overrideExisting: false,
});

export const { useListChampionshipsQuery } = championshipsApi;
